import { type MouseEvent, memo, useCallback } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useWorkspaceAgentSelectAssetStore } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/WorkspaceAgentSelectAssetStoreContext';

export const WorkspaceAgentSelectAssetClearButton = memo(() => {
  const value = useWorkspaceAgentSelectAssetStore((state) => state.value);
  const clear = useWorkspaceAgentSelectAssetStore((state) => state.clear);

  const handleClearMouseDown = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleClearClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      clear();
    },
    [clear],
  );

  if (!value) {
    return null;
  }

  return (
    <IconButton
      appearance="ghost"
      className="absolute top-1/2 right-2 -translate-y-1/2"
      color="gray"
      data-testid="WORKSPACE_AGENT_SELECT_ASSET_CLEAR"
      icon={XIcon}
      label="Clear"
      onClick={handleClearClick}
      onMouseDown={handleClearMouseDown}
      size="extra-small"
    />
  );
});

WorkspaceAgentSelectAssetClearButton.displayName = 'WorkspaceAgentSelectAssetClearButton';
